import { apiservice } from "./API.Services";
import { RestResponse } from "./D3AdminServices";

const { REACT_APP_API_BASE_URL } = process.env;

export { onboardingAPIService };

function onboardingAPIService() {

  return {
    request,
  };

  function request<R>(requestConfig: {
    method: string;
    url: string;
    data?: any;
    copyFn?: ((data: R) => R) | undefined;
  }): RestResponse<R> {

    if (REACT_APP_API_BASE_URL == null) {
      throw new Error("base url is not set.");
    }

    if (apiservice == null) {
      throw new Error("API service not available");
    }

    const url = REACT_APP_API_BASE_URL + requestConfig.url;

    if (requestConfig.method === "DELETE") {
      return apiservice.remove(url, requestConfig.data);
    }

    if (requestConfig.method === "GET") {
      return apiservice.get(url, requestConfig.data);
    }
    if (requestConfig.method === "POST") {
      return apiservice.post(
        url,
        requestConfig.data,
        undefined
      );
    }
    if (requestConfig.method === "PATCH") {
      return apiservice.patch(
        url,
        undefined,
        requestConfig.data
      );
    }
    if (requestConfig.method === "PUT") {
      return apiservice.put(
        url,
        requestConfig.data,
        undefined
      );
    }
    throw new Error("Method not implemented.");
  }
}
